var map = {
	"./africa/app.vue": [
		"sMUV",
		15
	],
	"./club-soft/app.vue": [
		"uDNj",
		18
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "CPMh";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/app lazy ^\.\/.*\/app\.vue$
// module id = CPMh
// module chunks = 37